import { render, staticRenderFns } from "./Arrivals.vue?vue&type=template&id=cff2af0e&scoped=true&"
import script from "./Arrivals.vue?vue&type=script&lang=js&"
export * from "./Arrivals.vue?vue&type=script&lang=js&"
import style0 from "./Arrivals.vue?vue&type=style&index=0&id=cff2af0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff2af0e",
  null
  
)

export default component.exports